import { render, staticRenderFns } from "./TabBenefit.vue?vue&type=template&id=253a2ced&"
import script from "./TabBenefit.vue?vue&type=script&lang=js&"
export * from "./TabBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports